import {API, Auth} from 'aws-amplify';
import LogRocket from "logrocket";
import * as AWS from "aws-sdk";

const cognito = new AWS.CognitoIdentityServiceProvider({
    apiVersion: "2016-04-18",
    region: process.env.REACT_APP_REGION,
    "accessKeyId": "AKIAW2TBXSLTXA4VUB74",
    "secretAccessKey": "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",
});

function getMyInitiDocumentDb() {
    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'find',
            limit: 10000,
            sort: [["user", 1]],
            query: { "type": {$in: [ "USER EXPLORER","USER BRONZE","USER SILVER", "USER GOLD"]}
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentDbAll() {
    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'find',
            limit: 10000,
            sort: [["user", 1]],
            query: {}
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentDbSavePermission(user) {
    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": "users_permission",
            "command": "update_many",
            "query": {
                "_id": {"$oid": user.id}
            },
            "update": {
                "$set": {
                    "type": user.permission
                }
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };;
    return myInitDb;
}


function getMyInitiDocumentDbDelete(user) {

    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'find_one_and_delete',
            query: {
                "user": user.user
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}

function getMyInitiDocumentDbCreate(user) {

    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'insert_one',
            doc: {
                user: user.user,
                name: user.user,
                createdAt: new Date(),
                type: "",
                stores: []
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}


async function validExist(user) {
    let myInitDb = {
        body: {
            database: process.env.REACT_APP_DATABASE,
            collection: 'users_permission',
            command: 'find',
            query: {
                user: user.user,
            }
        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };


    await API.post('dr', '/mongoDB', myInitDb).then(response => {
        //new Promise(r => setTimeout(r, 5000));
        //console.log(response.response.length);
        alert(response.response.length);
        return response.response.length;
    }).catch(erro => {
        LogRocket.captureException(erro);
    })

    /*return new Promise((resolve, reject) => {
        window.setTimeout(() => {
            resolve(API.post('dr', '/mongoDB', json))
        }, 1);
    });*/
}


export default {


    getAll: () =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbAll()).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    getRows: () =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb()).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    delete_old: (user) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbDelete(user)).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        }),

    create_OLD: (user) => {
        return API.post('dr', '/mongoDB', getMyInitiDocumentDbCreate(user)).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        })

    },

    savePermission: (user) => {
        return API.post('dr', '/mongoDB', getMyInitiDocumentDbSavePermission(user)).then(response => {
            return response.response;
        }).catch(erro => {
            LogRocket.captureException(erro);
        })

    },


    create: (user) => {
        const cognitoParams = {
            UserPoolId: process.env.REACT_APP_COGINITO_USER_POOL_ID,
            Username: user.user,
            UserAttributes: [{
                Name: "email",
                Value: user.user,
            },
                {
                    Name: "email_verified",
                    Value: "true",
                },
            ],
        };
        return cognito.adminCreateUser(cognitoParams).promise().then(response =>
            API.post('dr', '/mongoDB', getMyInitiDocumentDbCreate(user))
        ).then(resp => {
            return resp.EmbedUrl;
        }).catch(erro => {
            LogRocket.captureException(erro);
            let errorMessage = '';
            errorMessage = erro;
            throw errorMessage;

        })

    },


    delete: (user) => {
        const cognitoParams = {
            UserPoolId: process.env.REACT_APP_COGINITO_USER_POOL_ID,
            Username: user.user
        };
        return cognito.adminDeleteUser(cognitoParams).promise().then(response =>
            API.post('dr', '/mongoDB', getMyInitiDocumentDbDelete(user))
        ).then(resp => {
            return resp.EmbedUrl;
        }).catch(erro => {
            LogRocket.captureException(erro);
           // alert(erro);
        })
    },
};
